/** Behavioural constants shared by the calibration-report page, its components and its utilities. */

/** Rows per page in the employee table. */
export const TABLE_PAGE_SIZE = 15;

/** Delay after the last keystroke before a score/comment edit is saved. */
export const SAVE_DEBOUNCE_MS = 600;

/** Matches the backend's comment length limit. */
export const COMMENT_MAX_LENGTH = 2000;

/** Same 0-100 scale, with one decimal, as `CalibrationScoreScale` on the backend. */
export const SCORE_MIN = 0;
export const SCORE_MAX = 100;
export const SCORE_DECIMAL_PLACES = 1;

/** Bounds offered by the bulk-adjustment modal's percentage field. */
export const BULK_PERCENTAGE_MIN = 0.1;
export const BULK_PERCENTAGE_MAX = 50;
